import { initAccordion } from '@mpunkt-gmbh/sbr-assets/assets/js/src/accordion';

window.loadAccordion = function(accGroup) {
  initAccordion(accGroup);
};